
@if (getCurrentUser()) {
  <div>
    @if (isReady && iframeUrl) {
      <iframe [src]="iframeUrl" height="100%" width="100%"></iframe>
    } @else {
      <div class="center spinner-container">
        <div class="spinner-wrapper">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    }
  </div>
}
